// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeAdmin{
    display: flex;
    flex-direction: row;
    height: 100vh;
}

.HomeAdmin .main{
    margin-right: auto;
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.HomeAdmin .main .row{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/static/css/HomeAdmin.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".HomeAdmin{\n    display: flex;\n    flex-direction: row;\n    height: 100vh;\n}\n\n.HomeAdmin .main{\n    margin-right: auto;\n    margin-left: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.HomeAdmin .main .row{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
